/* ═══════════════════════════════════════════════════════════════
  custom.js — Snipe: Registro de cuenta (cart-accordion-contact)
  CAMBIOS: newCustomerResponse y submit handler corregidos
           ojito ver/ocultar contraseña corregido
           validación de existencia de documento en tiempo real
   ═══════════════════════════════════════════════════════════════ */

/* Este archivo es el dueño del formulario #new_cuenta cuando está presente en el
   carrito. custom.js declara un handler para el mismo #crearCuenta y, al cargarse
   en todo el tema, ambos respondían al mismo clic. La bandera hace que custom.js
   se abstenga aquí y así se envía una sola petición a new_customer.php. */
window.__cartCustomerFormOwner = true;

/* ─── Loader ──────────────────────────────────────────────────── */
function toggleLoader(state) {
  const el = document.getElementById('loading-overlay-customer');
  if (!el) return;
  el.classList.toggle('is-visible', state === 'show');
}

/* ─── Helpers ws-response ─────────────────────────────────────── */
function showWsResponse(msg, isError = true) {
  const ws = document.getElementById('ws-response');
  if (!ws) return;
  ws.innerHTML        = msg;
  ws.style.border     = isError ? '1px solid red' : '1px solid #28a745';
  ws.style.color      = isError ? '#c00'          : '#28a745';
  ws.style.display    = 'block';
  ws.style.visibility = 'visible';
}

function hideWsResponse() {
  const ws = document.getElementById('ws-response');
  if (!ws) return;
  ws.innerHTML        = '';
  ws.style.display    = 'none';
  ws.style.visibility = 'hidden';
  ws.style.border     = '';
  ws.style.color      = '';
}

/* ─── Serialización del formulario ───────────────────────────── */
function serializeForm(formId) {
  const formEl = document.getElementById(formId);
  if (!formEl) return false;

  const obj    = {};
  const errors = [];

  Array.from(formEl.elements).forEach(el => {
    const { name, value, type, required, checked } = el;
    if (!name) return;

    if ((value === 'falso' || value === '-') && required) {
      errors.push(name.toUpperCase());
      return;
    }

    if (['email', 'number', 'password'].includes(type)) {
      if (value.length >= 6) obj[name] = value;
      else if (required)     errors.push(name.toUpperCase());
      return;
    }

    if (type === 'checkbox') {
      if (!checked && required) errors.push(name.toUpperCase());
      if (checked)              obj[name] = value;
      return;
    }

    if (type === 'radio') {
      if (checked) obj[name] = value;
      return;
    }

    obj[name] = value;
  });

  // Validar que idIndicativo (hidden) tenga valor — el autocomplete visible no tiene name
  if (!obj['idIndicativo'] || obj['idIndicativo'] === '0') {
    errors.push('CÓD. PAÍS (INDICATIVO)');
  }

  if (errors.length) {
    showWsResponse(`Revisa los siguientes campos:<br>${errors.map(e => `* ${e}`).join('<br>')}`);
    return false;
  }

  return obj;
}

function cleanWsResponse() {
  hideWsResponse();
}

/* ─── Polling manual: verificar activación de cuenta ─────────── */
let _customerId = null;

async function checkAndHandleState() {
  const estadoEl = document.getElementById('swal-estado');
  const btn      = document.getElementById('swal-validar');

  if (btn) { btn.disabled = true; btn.textContent = 'Verificando...'; }

  try {
    const res  = await fetch(`${middlewareBaseUrl}ajax/checkCustomerState.php?customerId=${encodeURIComponent(_customerId)}`);
    const data = await res.json();

    if (data.state === 'ENABLED') {
      Swal.close();
      ventanaConfirma(
        '¡Cuenta activada!',
        'Tu cuenta ha sido activada. Ya puedes iniciar sesión.',
        'success',
        false, true, 'Iniciar sesión',
        '#e31c79', '#e31c79', '#F44336', '#fff', '20px', '-1rem 0 2rem 0', '4px 4px', true
      ).then(() => {
        document.getElementById('openLoginModal')?.click();
      }).catch(() => {});

    } else {
      if (estadoEl) {
        estadoEl.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e31c79" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="animation:swal-spin .8s linear infinite;vertical-align:middle;margin-right:6px">' +
            '<circle cx="12" cy="12" r="9" stroke-opacity=".2"/>' +
            '<path d="M12 3a9 9 0 0 1 9 9"/>' +
          '</svg>' +
          'Aún no detectamos la activación. Revisa tu correo e intenta de nuevo.';
      }
      if (btn) { btn.disabled = false; btn.textContent = 'Validar activación'; }
    }

  } catch (err) {
    console.error('checkAndHandleState:', err);
    if (estadoEl) estadoEl.textContent = 'Error al verificar. Intenta de nuevo.';
    if (btn) { btn.disabled = false; btn.textContent = 'Validar activación'; }
  }
}

/* EYPW6-312: el checkbox de términos se movió al resumen de compra; su estado
   visual y su validación viven ahora en sections/cart-summary.liquid. */

/* ─── Respuesta del endpoint new_customer.php ────────────────── */
function newCustomerResponse(data) {
  let obj;
  try {
    obj = typeof data === 'string' ? JSON.parse(data) : data;
  } catch {
    obj = { error: 1, message: 'Respuesta inválida del servidor.' };
  }

  const isReenvio = obj.message?.includes('reenviado');
  const title     = isReenvio ? 'Reenvío de Correo' : 'Registro Exitoso';

  /* ── Éxito (error === 0) ── */
  if (obj.error === 0) {
    _customerId = obj.customerId ?? null;
    hideWsResponse();

    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ attributes: { _direccion_pendiente: '' } }),
    }).catch(console.error);

    document.getElementById('new_cuenta_wrapper')?.style.setProperty('display', 'none');
    document.getElementById('registerSuccess')?.classList.remove('hide');
    window.scrollTo({ top: 0, behavior: 'smooth' });

    Swal.fire({
      icon: 'success',
      html: `
        <style>
          .swal2-success .swal2-success-ring          { border-color:#e31c79!important; }
          .swal2-success .swal2-success-line-tip,
          .swal2-success .swal2-success-line-long     { background-color:#e31c79!important; }
          div:where(.swal2-icon).swal2-success        { border-color:#e31c79!important; color:#e31c79!important; }
          .swal2-success-title                        { color:#e31c79!important; font-size:20px; font-weight:600; margin:10px 0; }
          @keyframes swal-spin { to { transform:rotate(360deg); } }
        </style>
        <div style="display:flex;flex-direction:column;align-items:center;text-align:center;margin:-1rem 0 2rem 0;">
          <div class="swal2-success-title">${title}</div>
          <div style="margin-bottom:16px;">${obj.message}</div>
          <small id="swal-estado" style="color:#888;margin-bottom:12px;display:block;"></small>
          ${_customerId ? `
            <button id="swal-validar" style="
              background:#e31c79;color:#fff;border:none;border-radius:10px;
              padding:12px 32px;font-size:1rem;cursor:pointer;width:100%;
              transition:background .2s;
            ">Validar activación</button>` : ''}
        </div>
      `,
      showConfirmButton: false,
      showCloseButton:   false,
      allowOutsideClick: false,
      didOpen: () => {
        document.getElementById('swal-validar')?.addEventListener('click', checkAndHandleState);
      }
    });
    return;
  }

  /* ── Teléfono inválido ── */
  if (obj.error === 2) {
    const tel = document.getElementById('Telefono');
    if (tel) { tel.value = ''; tel.focus(); }
    showWsResponse(obj.message || 'El número de teléfono no es válido.');
    return;
  }

  /* ── Cuenta ya activa (ENABLED) ── */
  if (obj.error === 3) {
    hideWsResponse();
    ventanaConfirma(
      'Cuenta ya activa', obj.message, 'warning',
      false, true, 'Iniciar sesión',
      '#e31c79', '#e31c79', '#F44336', '#fff', '20px', '-1rem 0 2rem 0', '4px 4px', true
    ).then(() => {
      document.getElementById('openLoginModal')?.click();
    }).catch(() => {});
    return;
  }

  /* ── Error genérico (error !== 0) ── */
  const msjError = (
    obj.message === 'Error creando cliente' &&
    obj.debug?.[0]?.message?.includes('Phone')
  )
    ? 'Error creando cliente: El teléfono ya se encuentra registrado.'
    : (obj.message || 'Ocurrió un error inesperado.');

  hideWsResponse();
  ventanaConfirma(
    'Registro Fallido', msjError, 'error',
    false, true, 'Aceptar',
    '#e31c79', '#e31c79', '#e31c79', '#fff', '20px', '-1rem 0 2rem 0', '4px 4px', true
  );
}

/* ─── Submit: crear cuenta ───────────────────────────────────── */
$(document).on('click', '#crearCuenta', async function (e) {
  e.preventDefault();

  const $btn  = $(this);
  const form  = document.getElementById('new_cuenta');
  if (!form) return;

  /* Candado contra envíos concurrentes / doble clic. */
  if (window.__creandoCuenta) return;

  // EYPW6-312: la aceptación de términos ya no vive en este formulario, se validó
  // antes en el resumen de compra (cart-totals.liquid). Aquí solo quedan los campos.
  form.classList.add('was-validated');

  if (!form.checkValidity()) return;

  /* ── Bloquear si el documento ya existe en sistema ──
     Se revalida contra el servicio en lugar de confiar en el flag: si el usuario
     corrigió el documento después de un error, el flag podía seguir en true y el
     mensaje se repetía como si estuviera cacheado. */
  if (await _regDocumentoYaExiste()) {
    showWsResponse('El tipo y número de documento ingresado ya se encuentra registrado en el sistema.');
    return;
  }

  const formData = serializeForm('new_cuenta');
  if (formData === false) {
    setTimeout(cleanWsResponse, 6000);
    return;
  }

  formData['address[province]'] = window._depto ?? '';
  formData['address[city]']     = window._city  ?? '';

  window.__creandoCuenta = true;
  $btn.hide();
  toggleLoader('show');
  hideWsResponse();

  try {
    const res = await fetch(middlewareBaseUrl + 'ws/new_customer.php', {
      method: 'POST',
      body:   new URLSearchParams(formData)
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);

    const text = await res.text();
    newCustomerResponse(text);

    let parsed;
    try { parsed = JSON.parse(text); } catch { parsed = { error: 1 }; }
    if (parsed.error !== 0) $btn.show();

  } catch (err) {
    console.error('crearCuenta:', err);
    showWsResponse('Error en la solicitud. Inténtalo de nuevo más tarde.');
    $btn.show();
  } finally {
    window.__creandoCuenta = false;
    toggleLoader('hide');
  }
});

  document.addEventListener('click', function (e) {
    if (!e.target.closest('#back-regis')) return;
    if (typeof StepperAPI !== 'undefined') StepperAPI.goTo(2);
  });

/* ─── Modal de login ─────────────────────────────────────────── */
function openLoginModal() {

  /* ── Elimina instancia previa si existe ── */
  document.getElementById('vtl-login-overlay')?.remove();

  /* ── Construye el modal directo en el DOM (sin Swal, sin DOMPurify) ── */
  const overlay = document.createElement('div');
  overlay.id    = 'vtl-login-overlay';
  overlay.style.cssText = [
    'position:fixed','inset:0','z-index:99999',
    'background:rgba(0,0,0,.5)',
    'display:flex','align-items:center','justify-content:center',
    'padding:20px','box-sizing:border-box'
  ].join(';');

  const card = document.createElement('div');
  card.style.cssText = [
    'background:#fff','border-radius:20px',
    'box-shadow:0 12px 48px rgba(0,0,0,.18)',
    'width:100%','max-width:420px',
    'padding:2rem','box-sizing:border-box',
    'position:relative'
  ].join(';');

  card.innerHTML = `
    <button id="vtl-login-close" style="position:absolute;top:14px;right:16px;background:none;border:none;font-size:20px;cursor:pointer;color:#aaa;line-height:1;">&#10005;</button>
    <div style="display:flex;flex-direction:column;align-items:center;text-align:center;">
      <div style="width:52px;height:52px;border-radius:50%;border:2px solid #e31c79;display:flex;align-items:center;justify-content:center;margin-bottom:16px;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#e31c79" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </div>
      <h2 style="color:#e31c79;font-size:1.2rem;font-weight:600;margin:0 0 6px;">Iniciar sesión</h2>
      <p style="color:#888;font-size:0.85rem;margin:0 0 20px;">Ingresa tus datos para continuar</p>
      <input type="email" id="vtl-login-email" placeholder="Correo electrónico"
        style="width:100%;padding:12px 14px;margin-bottom:12px;border:1.5px solid #ddd;border-radius:10px;font-size:0.93rem;outline:none;box-sizing:border-box;">
      <div style="position:relative;width:100%;margin-bottom:6px;">
        <input type="password" id="vtl-login-pw" placeholder="Contraseña"
          style="width:100%;padding:12px 42px 12px 14px;border:1.5px solid #ddd;border-radius:10px;font-size:0.93rem;outline:none;box-sizing:border-box;">
        <span id="vtl-login-eye" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);cursor:pointer;display:flex;align-items:center;"></span>
      </div>
      <div style="width:100%;text-align:right;margin-bottom:20px;">
        <a href="/account/login#recover" style="color:#e31c79;font-size:0.82rem;text-decoration:none;">¿Olvidaste tu contraseña?</a>
      </div>
      <div id="vtl-login-error" style="display:none;width:100%;padding:10px 14px;background:#fce8f3;border-radius:8px;color:#e31c79;font-size:0.83rem;margin-bottom:14px;text-align:left;box-sizing:border-box;"></div>
      <button id="vtl-login-btn" style="width:100%;background:#e31c79;color:#fff;border:none;border-radius:12px;padding:14px;font-size:1rem;cursor:pointer;letter-spacing:.03em;">
        Ingresar
      </button>
    </div>
  `;

  overlay.appendChild(card);
  document.body.appendChild(overlay);

  /* ── Referencias ── */
  const pwInput   = document.getElementById('vtl-login-pw');
  const eyeWrap   = document.getElementById('vtl-login-eye');
  const errorEl   = document.getElementById('vtl-login-error');
  const loginBtn  = document.getElementById('vtl-login-btn');
  const closeBtn  = document.getElementById('vtl-login-close');

  /* ── SVGs del ojito creados por DOM (no hay DOMPurify aquí) ── */
  const ns = 'http://www.w3.org/2000/svg';

  function makeSvg(open) {
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', '18'); svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', '#aaa'); svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
    if (open) {
      const p = document.createElementNS(ns, 'path');
      p.setAttribute('d', 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z');
      const c = document.createElementNS(ns, 'circle');
      c.setAttribute('cx', '12'); c.setAttribute('cy', '12'); c.setAttribute('r', '3');
      svg.appendChild(p); svg.appendChild(c);
    } else {
      const p1 = document.createElementNS(ns, 'path');
      p1.setAttribute('d', 'M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94');
      const p2 = document.createElementNS(ns, 'path');
      p2.setAttribute('d', 'M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19');
      const l  = document.createElementNS(ns, 'line');
      l.setAttribute('x1','1'); l.setAttribute('y1','1'); l.setAttribute('x2','23'); l.setAttribute('y2','23');
      svg.appendChild(p1); svg.appendChild(p2); svg.appendChild(l);
    }
    return svg;
  }

  eyeWrap.appendChild(makeSvg(true));

  eyeWrap.addEventListener('click', () => {
    const show   = pwInput.type === 'password';
    pwInput.type = show ? 'text' : 'password';
    eyeWrap.innerHTML = '';
    eyeWrap.appendChild(makeSvg(!show));
  });

  /* ── Cerrar modal ── */
  function closeModal() {
    overlay.remove();
  }
  closeBtn.addEventListener('click', closeModal);

  /* ── Focus en email ── */
  setTimeout(() => document.getElementById('vtl-login-email')?.focus(), 50);

  /* ── Enter en contraseña ── */
  pwInput.addEventListener('keydown', e => { if (e.key === 'Enter') loginBtn.click(); });

  /* ── Login ── */
  loginBtn.addEventListener('click', async () => {
    const email    = document.getElementById('vtl-login-email').value.trim();
    const password = pwInput.value;

    errorEl.style.display = 'none';

    if (!email || !password) {
      errorEl.style.display = 'block';
      errorEl.textContent   = 'Por favor completa todos los campos.';
      return;
    }

    loginBtn.disabled         = true;
    loginBtn.textContent      = 'Ingresando...';
    loginBtn.style.background = '#c2156a';

    try {
      const body = new URLSearchParams({
        'form_type':          'customer_login',
        'utf8':               '✓',
        'customer[email]':    email,
        'customer[password]': password,
        'return_to':          window.location.pathname + '?tab=contacto'
      });

      const res = await fetch('/account/login', {
        method:   'POST',
        headers:  { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:     body.toString(),
        redirect: 'follow'
      });

      const loginOk = !new URL(res.url).pathname.includes('/account/login');

      if (loginOk) {
        closeModal();
        window.location.href = window.location.pathname + '?tab=contacto';
      } else {
        errorEl.style.display = 'block';
        errorEl.textContent   = 'Correo o contraseña incorrectos. Intenta de nuevo.';
        loginBtn.disabled          = false;
        loginBtn.textContent       = 'Ingresar';
        loginBtn.style.background  = '#e31c79';
      }
    } catch (err) {
      console.error(err);
      errorEl.style.display = 'block';
      errorEl.textContent   = 'Error de conexión. Intenta de nuevo.';
      loginBtn.disabled          = false;
      loginBtn.textContent       = 'Ingresar';
      loginBtn.style.background  = '#e31c79';
    }
  });
}

/* ─── Vincula el botón #openLoginModal al modal ───────────────── */
document.addEventListener('click', function (e) {
  if (e.target.closest('#openLoginModal')) {
    e.preventDefault();
    openLoginModal();
  }
});

/* ═══════════════════════════════════════════════════════════════
   VALIDACIÓN DE EXISTENCIA DE DOCUMENTO — Formulario de registro
   Consume: ajax/checkPatientDocument.php
   Aplica feedback en: #TipoDocumento y #Documento
   Flag global: window._regDocExiste (bloquea el submit)
═══════════════════════════════════════════════════════════════ */
window._regDocExiste   = false;
var _regDocTimer       = null;
/* Secuencia de peticiones: descarta respuestas que llegan fuera de orden y que
   dejarían el flag en un valor viejo aunque el usuario ya corrigió el documento. */
var _regDocSeq         = 0;
/* Último par tipo+documento efectivamente verificado, para saber si el flag
   corresponde a lo que hay ahora mismo en el formulario. */
var _regDocChecked     = null;

/**
 * Muestra u oculta el feedback de "documento existente" en el formulario de registro.
 * @param {boolean} visible  - true = mostrar error, false = ocultar
 */
function _setRegDocExistsFeedback(visible) {
  var feedbackTipo = document.getElementById('doc-exists-tipodoc-reg');
  var feedbackDoc  = document.getElementById('doc-exists-doc-reg');
  var inputTipo    = document.getElementById('TipoDocumento');
  var inputDoc     = document.getElementById('Documento');

  if (feedbackTipo) feedbackTipo.classList.toggle('is-visible', visible);
  if (feedbackDoc)  feedbackDoc.classList.toggle('is-visible', visible);

  if (inputTipo) {
    inputTipo.classList.toggle('doc-exists-error', visible);
    inputTipo.classList.toggle('is-invalid', visible);
    if (visible) inputTipo.classList.remove('is-valid');
    // NO setCustomValidity en el select
  }
  if (inputDoc) {
    inputDoc.classList.toggle('doc-exists-error', visible);
    inputDoc.classList.toggle('is-invalid', visible);
    if (visible) inputDoc.classList.remove('is-valid');
    inputDoc.setCustomValidity(visible ? 'Documento existente.' : '');
  }
}

/**
 * Llama al endpoint PHP y actualiza el flag + UI.
 */
async function _checkRegDocumento() {
  var docInput  = document.getElementById('Documento');
  var tipoInput = document.getElementById('TipoDocumento');
  if (!docInput || !tipoInput) return false;

  var doc    = (docInput.value  || '').trim();
  var tipoId = (tipoInput.value || '').trim();
  var clave  = tipoId + '|' + doc;

  /* No verificar si faltan datos mínimos. Sin cuenta (cart-guest-checkout.js)
     un documento existente no es error: es un paciente que vuelve. */
  if (window.__guestCheckout || doc.length < 3 || !tipoId || tipoId === '0' || tipoId === '') {
    _regDocSeq++;                 /* invalida cualquier respuesta en vuelo */
    _regDocChecked = null;
    _setRegDocExistsFeedback(false);
    window._regDocExiste = false;
    return false;
  }

  var seq = ++_regDocSeq;

  try {
    var base = window.middlewareBaseUrl || '';
    var url  = base + 'ws/checkPatientDocument.php'
             + '?documento='       + encodeURIComponent(doc)
             + '&idTipoDocumento=' + encodeURIComponent(tipoId)
             + '&idPaciente=0';

    var res  = await fetch(url, { cache: 'no-store' });
    var data = await res.json();

    /* Otra verificación más reciente ya salió: esta respuesta es vieja. */
    if (seq !== _regDocSeq) return window._regDocExiste;

    window._regDocExiste = (data.existe === true);
    _regDocChecked       = clave;
    _setRegDocExistsFeedback(window._regDocExiste);
    return window._regDocExiste;

  } catch (e) {
    if (seq !== _regDocSeq) return window._regDocExiste;
    /* Si el servicio falla, no bloqueamos al usuario */
    window._regDocExiste = false;
    _regDocChecked       = null;
    _setRegDocExistsFeedback(false);
    return false;
  }
}

/**
 * Devuelve true si el documento actual del formulario ya existe, revalidando
 * contra el servicio cuando el flag no corresponde a los valores actuales.
 */
async function _regDocumentoYaExiste() {
  var docInput  = document.getElementById('Documento');
  var tipoInput = document.getElementById('TipoDocumento');
  if (!docInput || !tipoInput) return false;

  var clave = (tipoInput.value || '').trim() + '|' + (docInput.value || '').trim();

  /* El flag solo es confiable si se calculó con el tipo y documento que hay ahora. */
  if (_regDocChecked === clave) return window._regDocExiste === true;

  clearTimeout(_regDocTimer);
  return await _checkRegDocumento();
}

/* ─── initContactoPanel ──────────────────────────────────────── */
function initContactoPanel(panel) {
  var base = window.middlewareBaseUrl;
  if (!base) return;
  /* Sin cuenta el panel lo maneja cart-guest-checkout.js (catálogos y validaciones) */
  if (window.__guestCheckout) return;

  /* 1. Tipos de documento */
  var tipoDoc = panel.querySelector('#TipoDocumento');
  if (tipoDoc && tipoDoc.options.length <= 1) {
    fetch(base + 'ajax/genericConsult.php?action=ConsultDocumentType')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        data.forEach(function (item) {
          var opt = document.createElement('option');
          opt.text  = item.tipodocumento;
          opt.value = item.id;
          tipoDoc.add(opt);
        });
      }).catch(console.error);
  }

  /* Listener: cuando cambia el tipo de documento, revalidar existencia */
  if (tipoDoc && !tipoDoc.dataset.docExistsDone) {
    tipoDoc.dataset.docExistsDone = '1';
    tipoDoc.addEventListener('change', function () {
      clearTimeout(_regDocTimer);
      _regDocTimer = setTimeout(_checkRegDocumento, 300);
    });
  }

  /* 2. Departamentos */
  var dSelect = panel.querySelector('#DepartamentoC');
  if (dSelect && dSelect.options.length <= 1) {
    fetch(base + 'ajax/genericConsult.php?action=consultDepartment')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        data.forEach(function (item) {
          dSelect.add(new Option(item.depto, item.id));
        });

        dSelect.addEventListener('change', function () {
          window._depto = this.selectedOptions[0].text;
          fetch(base + 'ajax/genericConsult.php?action=consultCitDepartment&departament_Id=' + this.value)
            .then(function (r) { return r.json(); })
            .then(function (cities) {
              var wrapper = panel.querySelector('#Ciudadver');
              var cSelect = panel.querySelector('#AddressCityNew');
              if (!wrapper || !cSelect) return;

              if (cities && cities.length) {
                wrapper.style.display = 'block';
                var fresh = cSelect.cloneNode(false);
                fresh.innerHTML = '<option value="">Seleccione una ciudad</option>';
                cities.forEach(function (c) { fresh.add(new Option(c.ciudad, c.id)); });
                fresh.addEventListener('change', function () {
                  window._city = this.selectedOptions[0].text;
                });
                cSelect.replaceWith(fresh);
              } else {
                wrapper.style.display = 'none';
              }
            }).catch(console.error);
        });
      }).catch(console.error);
  }

  /* 3. Indicativo de país */
  var codPaisInput = panel.querySelector('#codPais');
  var codPaisId    = panel.querySelector('#codPaisId');
  if (codPaisInput && !codPaisInput.dataset.initDone) {
    codPaisInput.dataset.initDone = '1';
    fetch(base + 'ajax/genericConsult.php?action=consultIndicativo')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        $(codPaisInput).autocomplete({
          source: data.map(function (item) {
            return { label: item.pais + ' (' + item.indicativo + ')', value: item.pais + ' (' + item.indicativo + ')', id: item.indicativo };
          }),
          minLength: 0,
          select: function (event, ui) {
            if (codPaisId) codPaisId.value = ui.item.id;
            codPaisInput.value = ui.item.value;
            return false;
          }
        }).on('focus', function () { $(this).autocomplete('search', ''); });
      }).catch(console.error);
  }

  /* 4. Validación Documento */
  var docInput = panel.querySelector('#Documento');
  if (docInput && !docInput.dataset.initDone) {
    docInput.dataset.initDone = '1';
    docInput.addEventListener('input', function () {
      this.value = this.value.replace(/[^a-zA-Z0-9\-]/g, '');
      this.setCustomValidity(
        this.value.length < 3  ? 'Mínimo 3 caracteres.'  :
        this.value.length > 20 ? 'Máximo 20 caracteres.' : ''
      );
      /* Limpiar feedback mientras se escribe menos de 3 chars */
      if (this.value.length < 3) {
        clearTimeout(_regDocTimer);
        _setRegDocExistsFeedback(false);
        window._regDocExiste = false;
        return;
      }
      /* Debounce 600ms para no saturar el servicio */
      clearTimeout(_regDocTimer);
      _regDocTimer = setTimeout(_checkRegDocumento, 600);
    });
  }

  /* 5. Validación Teléfono */
  var telInput = panel.querySelector('#Telefono');
  if (telInput && !telInput.dataset.initDone) {
    telInput.dataset.initDone = '1';

    telInput.setAttribute('maxlength', '10');
    telInput.setAttribute('minlength', '7');
    telInput.setAttribute('inputmode', 'numeric');
    telInput.setAttribute('pattern', '[0-9]{7,10}');

    telInput.addEventListener('input', function () {
      var clean = this.value.replace(/[^0-9]/g, '');
      if (clean.length > 10) clean = clean.slice(0, 10);
      this.value = clean;

      var len = clean.length;
      if (len === 0) {
        this.setCustomValidity('El teléfono es obligatorio.');
      } else if (len < 7) {
        this.setCustomValidity('El teléfono debe tener mínimo 7 dígitos.');
      } else if (len > 10) {
        this.setCustomValidity('El teléfono no puede superar 10 dígitos.');
      } else {
        this.setCustomValidity('');
      }
    });

    telInput.addEventListener('blur', function () {
      telInput.dispatchEvent(new Event('input'));
    });
  }

  /* 6. Validación Fecha de nacimiento */
  var fechaInput = panel.querySelector('#FechaNacimiento');
  if (fechaInput && !fechaInput.dataset.initDone) {
    fechaInput.dataset.initDone = '1';

    var hoy     = new Date();
    /* R5: se aceptan recién nacidos, como en el CTS. */
    var maxDate = new Date(hoy.getFullYear(),       hoy.getMonth(), hoy.getDate());
    var minDate = new Date(hoy.getFullYear() - 120,  hoy.getMonth(), hoy.getDate());
    fechaInput.max = maxDate.toISOString().split('T')[0];
    fechaInput.min = minDate.toISOString().split('T')[0];

    function validarFechaNacimiento() {
      var val = fechaInput.value;
      if (!val) { fechaInput.setCustomValidity('La fecha de nacimiento es obligatoria.'); return; }
      var fecha = new Date(val + 'T00:00:00');
      var hoyMs = new Date(); hoyMs.setHours(0, 0, 0, 0);
      if (isNaN(fecha.getTime())) { fechaInput.setCustomValidity('La fecha no es válida.'); return; }
      if (fecha > hoyMs) { fechaInput.setCustomValidity('La fecha no puede ser posterior a hoy.'); return; }
      var edad = hoyMs.getFullYear() - fecha.getFullYear();
      var m    = hoyMs.getMonth() - fecha.getMonth();
      if (m < 0 || (m === 0 && hoyMs.getDate() < fecha.getDate())) edad--;
      if (edad > 120) { fechaInput.setCustomValidity('La fecha ingresada no es válida.'); return; }
      fechaInput.setCustomValidity('');
    }

    fechaInput.addEventListener('change', validarFechaNacimiento);
    fechaInput.addEventListener('blur',   validarFechaNacimiento);
    if (fechaInput.value) validarFechaNacimiento();
  }

  /* 7. Botón login */
  var loginBtn = panel.querySelector('#openLoginModal');
  if (loginBtn) {
    var freshBtn = loginBtn.cloneNode(true);
    loginBtn.replaceWith(freshBtn);
    freshBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openLoginModal();
    });
  }
}

/* ─── ventanaConfirma ────────────────────────────────────────── */
function ventanaConfirma(
  titulo, texto, icon,
  mostrarCancelar, mostrarConfirmar, nomboton,
  iconColor, buttonColor, cancelButtonColor,
  backgroundColor, borderRadius, margen, padding, useAnimations
) {
  document.head.insertAdjacentHTML('beforeend', `<style>
    .swal2-popup { background-color:${backgroundColor}!important; border-radius:${borderRadius}!important; padding:${padding}!important; }
    div:where(.swal2-icon).swal2-success,
    div:where(.swal2-icon).swal2-error,
    div:where(.swal2-icon).swal2-warning { color:${iconColor}!important; border-color:${iconColor}!important; }
    .swal2-success .swal2-success-line-tip,
    .swal2-success .swal2-success-line-long { background-color:${iconColor}!important; }
    .swal2-success .swal2-success-ring { border:.25em solid ${iconColor}!important; }
    .swal2-error .swal2-x-mark-line-left,
    .swal2-error .swal2-x-mark-line-right { background-color:${iconColor}!important; }
    .swal2-success-title { color:${iconColor}!important; font-size:20px; font-weight:600; margin:10px 0; }
    .swal2-confirm { background-color:${buttonColor}!important; padding:16px!important; border-radius:10px!important; color:#fff!important; margin:0 0 1rem; }
    .swal2-cancel  { background-color:${cancelButtonColor}!important; padding:16px!important; border-radius:10px!important; color:#fff!important; }
  </style>`);

  return new Promise((resolve, reject) => {
    Swal.fire({
      icon,
      html: `
        <div style="display:flex;flex-direction:column;align-items:center;text-align:center;margin:${margen};">
          ${icon === 'success'
            ? `<div class="swal2-success-title">${titulo}</div>`
            : `<div style="font-size:18px;font-weight:600;margin-bottom:8px;color:${iconColor}">${titulo}</div>`
          }
          <div>${texto}</div>
        </div>
      `,
      showCancelButton:   mostrarCancelar,
      showConfirmButton:  mostrarConfirmar,
      showCloseButton:    true,
      allowOutsideClick:  false,
      confirmButtonText:  nomboton,
      cancelButtonText:   'Cancelar',
      didOpen() { document.querySelector('.swal2-loader')?.remove(); }
    }).then(r => r.isConfirmed ? resolve() : reject());
  });
}